function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1572B6",
  d: "M18.814 114.123L8.76 1.352h110.48l-10.064 112.754-45.243 12.543-45.119-12.526z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#33A9DC",
  d: "M64.001 117.062l36.559-10.136 8.601-96.354h-45.16v106.49z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M64.001 51.429h18.302l1.264-14.163H64.001V23.435h34.682l-.332 3.711-3.4 38.114h-30.95V51.429z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M64.083 87.349l-.061.018-15.403-4.159-.985-11.031H33.752l1.937 21.717 28.331 7.863.063-.018v-14.39z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M81.127 64.675l-1.666 18.522-15.426 4.164v14.39l28.354-7.858.208-2.337 2.406-26.881H81.127z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M64.048 23.435v13.831H30.64l-.277-3.108-.63-7.012-.331-3.711h34.646zm-.047 27.996v13.831H48.792l-.277-3.108-.631-7.012-.33-3.711h16.447z"
});

function SvgCsslogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    width: 56
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgd2lkdGg9IjU2cHgiPgoJPHBhdGggZmlsbD0iIzE1NzJCNiIgZD0iTTE4LjgxNCAxMTQuMTIzbC0xMC4wNTQtMTEyLjc3MWgxMTAuNDhsLTEwLjA2NCAxMTIuNzU0LTQ1LjI0MyAxMi41NDMtNDUuMTE5LTEyLjUyNnoiPgoJPC9wYXRoPgoJPHBhdGggZmlsbD0iIzMzQTlEQyIgZD0iTTY0LjAwMSAxMTcuMDYybDM2LjU1OS0xMC4xMzYgOC42MDEtOTYuMzU0aC00NS4xNnYxMDYuNDl6Ij4KCTwvcGF0aD4KCTxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik02NC4wMDEgNTEuNDI5aDE4LjMwMmwxLjI2NC0xNC4xNjNoLTE5LjU2NnYtMTMuODMxaDM0LjY4MTk5OTk5OTk5OTk5NWwtLjMzMiAzLjcxMS0zLjQgMzguMTE0aC0zMC45NXYtMTMuODMxeiI+Cgk8L3BhdGg+Cgk8cGF0aCBmaWxsPSIjRUJFQkVCIiBkPSJNNjQuMDgzIDg3LjM0OWwtLjA2MS4wMTgtMTUuNDAzLTQuMTU5LS45ODUtMTEuMDMxaC0xMy44ODJsMS45MzcgMjEuNzE3IDI4LjMzMSA3Ljg2My4wNjMtLjAxOHYtMTQuMzl6Ij4KCTwvcGF0aD4KCTxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik04MS4xMjcgNjQuNjc1bC0xLjY2NiAxOC41MjItMTUuNDI2IDQuMTY0djE0LjM5bDI4LjM1NC03Ljg1OC4yMDgtMi4zMzcgMi40MDYtMjYuODgxaC0xMy44NzZ6Ij4KCTwvcGF0aD4KCTxwYXRoIGZpbGw9IiNFQkVCRUIiIGQ9Ik02NC4wNDggMjMuNDM1djEzLjgzMTAwMDAwMDAwMDAwMWgtMzMuNDA3OTk5OTk5OTk5OTk0bC0uMjc3LTMuMTA4LS42My03LjAxMi0uMzMxLTMuNzExaDM0LjY0NnpNNjQuMDAxIDUxLjQzMXYxMy44MzEwMDAwMDAwMDAwMDFoLTE1LjIwOWwtLjI3Ny0zLjEwOC0uNjMxLTcuMDEyLS4zMy0zLjcxMWgxNi40NDd6Ij4KCTwvcGF0aD4KPC9zdmc+Cg==";
export { SvgCsslogo as ReactComponent };